<button
  kendoButton
  fillMode="outline"
  themeColor="primary"
  #itemFilterAnchor
  (click)="togglePanel()"
>
  <fa-icon [icon]="['fas', 'filter']" style="margin-right: 6px"></fa-icon>
  <span>{{ label }}</span>
  <kendo-chip
    *ngIf="selectedCount > 0"
    themeColor="info"
    rounded="full"
    size="small"
    style="margin-left: 6px"
    >{{ selectedCount }}</kendo-chip
  >
</button>

<kendo-popup
  *ngIf="dropdownVisible"
  [anchor]="anchor"
  [animate]="true"
  (anchorViewportLeave)="closePanel()"
>
  <div class="item-filter-panel">
    <div class="item-filter-panel__header">
      <div class="autocomplete-container">
        <kendo-textbox (valueChange)="handleFilter($event)">
          <ng-template kendoPrefixTemplate>
            <button kendoButton fillMode="flat">
              <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
            </button>
          </ng-template>
        </kendo-textbox>
      </div>

      <button kendoButton fillMode="flat" size="small" (click)="closePanel()">
        <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
      </button>
    </div>

    <div class="m-t-4">
      <kendo-checkbox
        #selectAll
        [checkedState]="allSelected"
        (change)="toggleSelectAll()"
      ></kendo-checkbox>
      <kendo-label [for]="selectAll">Select All</kendo-label>
    </div>

    <kendo-listview
      [height]="pageSize * 10"
      containerClass="k-d-flex k-flex-col k-flex-nowrap"
      (scrollBottom)="handleScroll()"
      [data]="selectableItems"
      class="m-t-2 m-l-4"
    >
      <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
        <kendo-checkbox
          [checkedState]="dataItem.selected"
          (change)="toggleSelect(dataItem)"
        ></kendo-checkbox>
        <kendo-label>{{ dataItem.label }}</kendo-label>
      </ng-template>
    </kendo-listview>

    <div class="k-actions k-actions-stretched k-actions-horizontal item-filter-panel__footer">
      <button kendoButton themeColor="primary" (click)="applyFilter()">
        Filter
      </button>
      <button kendoButton themeColor="base" (click)="clearSelection()">
        Clear
      </button>
    </div>
  </div>
</kendo-popup>
